import { Extension } from "@tiptap/core";
import { Plugin, PluginKey } from "@tiptap/pm/state";
import { Decoration, DecorationSet } from "@tiptap/pm/view";

import { getCellsForSelection, isCellSelection } from "../Table/utils";

export const Selection = Extension.create({
  name: "selection",

  addProseMirrorPlugins() {
    const { editor } = this;

    return [
      new Plugin({
        key: new PluginKey("selection"),
        props: {
          decorations(state) {
            const { selection } = state;

            if (selection.empty) {
              return null;
            }

            if (editor.isFocused === true) {
              return null;
            }

            // A CellSelection's own from/to are just its anchor/head cell boundaries — the
            // linear range between them cuts across row/cell node boundaries and isn't a legal
            // inline range, which is why highlighting across cells rendered wrong/partial.
            // Highlight each selected cell's own content instead of the whole span.
            if (isCellSelection(selection)) {
              const cells = getCellsForSelection(selection);
              if (!cells || !cells.length) {
                return null;
              }

              return DecorationSet.create(
                state.doc,
                cells
                  .filter((cell): cell is typeof cell & { node: NonNullable<typeof cell.node> } => !!cell.node)
                  .map(({ pos, node }) => Decoration.inline(pos + 1, pos + node.nodeSize - 1, { class: "selection" }))
              );
            }

            return DecorationSet.create(state.doc, [
              Decoration.inline(selection.from, selection.to, {
                class: "selection",
              }),
            ]);
          },
        },
      }),
    ];
  },
});

export default Selection;
